// Generated by ServiceInterfaceGenerator Aug 28, 2018 11:02:47 AM
import { sharedReactorWebsocket as ws } from '../reactor.js';

class VotingServiceInterface {
  constructor() {
    this.service_id = 'votingservice-1_2';
  }

  // OpenPollAction, Response: Integer
  // sessionId: int
  // questionId: int
  // forceCloseRunningPoll: Optional<Boolean>
  openPoll(sessionId, questionId, forceCloseRunningPoll, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'OpenPollAction', { sessionId: sessionId, questionId: questionId, forceCloseRunningPoll: forceCloseRunningPoll }, success_callback);
  }

  // OpenPollWithCountDownAction, Response: Integer
  // sessionId: int
  // questionId: int
  // countDownMillis: int
  // forceCloseRunningPoll: Optional<Boolean>
  openPollWithCountDown(sessionId, questionId, countDownMillis, forceCloseRunningPoll, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'OpenPollWithCountDownAction', { sessionId: sessionId, questionId: questionId, countDownMillis: countDownMillis, forceCloseRunningPoll: forceCloseRunningPoll }, success_callback);
  }

  // OpenGroupPollAction, Response: OpenGroupPollResponse
  // sessionId: int
  // groupId: String
  // forceCloseRunningPoll: Optional<Boolean>
  openGroupPoll(sessionId, groupId, forceCloseRunningPoll, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'OpenGroupPollAction', { sessionId: sessionId, groupId: groupId, forceCloseRunningPoll: forceCloseRunningPoll }, success_callback);
  }

  // ReOpenPollAction, Response: Integer
  // sessionId: int
  // pollId: int
  // includedQuestionIds: Optional<List<Integer>>
  // forceCloseRunningPoll: Optional<Boolean>
  reOpenPoll(sessionId, pollId, includedQuestionIds, forceCloseRunningPoll, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ReOpenPollAction', { sessionId: sessionId, pollId: pollId, includedQuestionIds: includedQuestionIds, forceCloseRunningPoll: forceCloseRunningPoll }, success_callback);
  }

  // ReOpenPollAction, Response: Integer
  // sessionId: int
  // pollId: int
  // includedQuestionIds: Optional<List<Integer>>
  // countDownMillis: int
  // forceCloseRunningPoll: Optional<Boolean>
  reOpenPollWithCountDown(sessionId, pollId, includedQuestionIds, countDownMillis, forceCloseRunningPoll, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ReOpenPollWithCountDownAction', { sessionId: sessionId, pollId: pollId, includedQuestionIds: includedQuestionIds, countDownMillis: countDownMillis, forceCloseRunningPoll: forceCloseRunningPoll }, success_callback);
  }

  // CancelPollAction, Response: Boolean
  // sessionId: int
  // pollId: int
  cancelPoll(sessionId, pollId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'CancelPollAction', { sessionId: sessionId, pollId: pollId }, success_callback);
  }

  // ClosePollAction, Response: Boolean
  // sessionId: int
  // pollId: int
  // waitUntilClosed: Optional<Boolean>
  closePoll(sessionId, pollId, waitUntilClosed, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ClosePollAction', { sessionId: sessionId, pollId: pollId, waitUntilClosed: waitUntilClosed }, success_callback);
  }

  // DisplayResultsAction, Response: Boolean
  // sessionId: int
  // pollId: int
  // correctAnswersDisplay: Optional<List<QuestionDisplayCorrectAnswer>>
  displayResults(sessionId, pollId, correctAnswersDisplay, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'DisplayResultsAction', { sessionId: sessionId, pollId: pollId, correctAnswersDisplay: correctAnswersDisplay }, success_callback);
  }

  // DisplayCorrectAnswersAction, Response: Boolean
  // sessionId: int
  // pollId: int
  // display: List<QuestionDisplayCorrectAnswer>
  displayCorrectAnswers(sessionId, pollId, display, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'DisplayCorrectAnswersAction', { sessionId: sessionId, pollId: pollId, display: display }, success_callback);
  }

  // FinishPollAction, Response: Boolean
  // sessionId: int
  // pollId: int
  finishPoll(sessionId, pollId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'FinishPollAction', { sessionId: sessionId, pollId: pollId }, success_callback);
  }

  // TakePollOwnership, Response: Boolean
  // sessionId: int
  // pollId: int
  takePollOwnership(sessionId, pollId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'TakePollOwnership', { sessionId: sessionId, pollId: pollId }, success_callback);
  }

  // sends Subscribe to subscribe and Unsubscribe to unsubscribe
  // session_id: int
  subscribeForSessionPollState(session_id, success_callback, handlers) {
    var subscribe_msg = { service: this.service_id, message: 'Subscribe', data: { topic: '/' + this.service_id + '/polls/admin/' + session_id, filter: null } };
    var unsubscribe_msg = { service: this.service_id, message: 'Unsubscribe', data: { topic: '/' + this.service_id + '/polls/admin/' + session_id } };
    return ws.subscribeWithHandlers(subscribe_msg, unsubscribe_msg, success_callback, handlers);
  }

  // LivePollCountRequest, Response: LivePollCountResponseVer2
  // sessionId: int
  // pollId: int
  getLivePollCount(sessionId, pollId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'LivePollCountRequest', { sessionId: sessionId, pollId: pollId }, success_callback);
  }

  // LivePollResponseListRequest, Response: LivePollResponseListResponse
  // sessionId: int
  // pollId: int
  // lastCalled: Optional<Integer>
  getLivePollResponseList(sessionId, pollId, lastCalled, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'LivePollResponseListRequest', { sessionId: sessionId, pollId: pollId, lastCalled: lastCalled }, success_callback);
  }

  // ActivePollStateRequest, Response: ActivePollStateResponse
  // sessionId: int
  // pollId: int
  getActivePollState(sessionId, pollId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ActivePollStateRequest', { sessionId: sessionId, pollId: pollId }, success_callback);
  }

  // ActivePollStateRequest, Response: ActivePollStateResponse
  // sessionId: int
  // pollId: int
  get(sessionId, pollId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ActivePollStateRequest', { sessionId: sessionId, pollId: pollId }, success_callback);
  }

  // ClosePollAndDisplayResultsAction, Response: ResultSetResponseVer2
  // sessionId: int
  // pollId: int
  // wordCloud: Optional<WordCloudParameters>
  closePollAndDisplayResults(sessionId, pollId, wordCloud, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ClosePollAndDisplayResultsAction', { sessionId: sessionId, pollId: pollId, wordCloud: wordCloud }, success_callback);
  }

  // OpenLeaderboardAction, Response:
  // sessionId: int
  // questionIds: Optional<List<String>>
  // forceCloseRunningPoll: Optional<Boolean>
  openLeaderboard(sessionId, questionIds, forceCloseRunningPoll, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'OpenLeaderboardAction', { sessionId: sessionId, questionIds: questionIds, forceCloseRunningPoll: forceCloseRunningPoll }, success_callback);
  }

  // CloseLeaderboardAction, Response:
  // sessionId: int
  // leaderboardId: String
  closeLeaderboard(sessionId, leaderboardId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'CloseLeaderboardAction', { sessionId: sessionId, leaderboardId: leaderboardId }, success_callback);
  }

  // ResetPollStateAction, Response: ResetPollStateResponse
  // sessionId: int
  resetPollState(sessionId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ResetPollStateAction', { sessionId: sessionId }, success_callback);
  }

  // GetNextLeaderboardTopListItemsRequest, Response:
  // sessionId: int
  // leaderboardId: String
  // fromPosition: int
  getNextLeaderboardTopListItems(sessionId, leaderboardId, fromPosition, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'GetNextLeaderboardTopListItemsRequest', { sessionId: sessionId, leaderboardId: leaderboardId, fromPosition: fromPosition }, success_callback);
  }

  /*
    CreateGroupAndOpenGroupPollAction = {
      sessionId: Int
      questionIds: List<Integer>
      forceCloseRunningPoll: Optional<Boolean>
    }
  */
  createGroupAndOpenGroupPoll(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'CreateGroupAndOpenGroupPollAction', request, success_callback);
  }

  createQuestionAndOpenPollAction(sessionId, question, originId, forceCloseRunningPoll, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'CreateQuestionAndOpenPollAction', { sessionId: sessionId, question: question, originId: originId, forceCloseRunningPoll: forceCloseRunningPoll }, success_callback);
  }

  showTextResponse(sessionId, questionId, responseId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ShowTextResponseAction', { sessionId: sessionId, questionId: questionId, responseId: responseId }, success_callback);
  }

  hideTextResponse(sessionId, questionId, responseId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'HideTextResponseAction', { sessionId: sessionId, questionId: questionId, responseId: responseId }, success_callback);
  }

  showWordFrequency(sessionId, questionId, text, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ShowFrequencyAction', { sessionId: sessionId, questionId: questionId, text: text }, success_callback);
  }

  hideWordFrequency(sessionId, questionId, text, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'HideFrequencyAction', { sessionId: sessionId, questionId: questionId, text: text }, success_callback);
  }

  createPollCountDownTimer(sessionId, pollId, duration, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'CreatePollCountDownTimerAction', { sessionId: sessionId, pollId: pollId, durationMillis: duration }, success_callback);
  }

  increasePollCountDownTimer(sessionId, pollId, duration, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'IncreasePollCountDownTimerAction', { sessionId: sessionId, pollId: pollId, durationMillis: duration }, success_callback);
  }

  pausePollCountDownTimer(sessionId, pollId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'PausePollCountDownTimerAction', { sessionId: sessionId, pollId: pollId }, success_callback);
  }

  resumePollCountDownTimer(sessionId, pollId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ResumePollCountDownTimerAction', { sessionId: sessionId, pollId: pollId }, success_callback);
  }

  cancelPollCountDownTimer(sessionId, pollId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'CancelPollCountDownTimerAction', { sessionId: sessionId, pollId: pollId }, success_callback);
  }

  setShowLiveResults(sessionId, pollId, isLiveResultsEnabled, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'SetLiveResultsEnabledAction', { sessionId: sessionId, pollId: pollId, isEnabled: isLiveResultsEnabled }, success_callback);
  }
}

export const ActivePollState = Object.freeze({
  open: 'open',
  closing: 'closing',
  closed: 'closed',
  results: 'results'
});

export const votingService = new VotingServiceInterface();


//////////////////
// WEBPACK FOOTER
// ../ReactorJSCore/dist/services/votingservice.js
// module id = null
// module chunks = 